import React from 'react';
import PropTypes from 'prop-types';
import { recordEvent } from '../../../services/events-service';

export default class GoogleButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventType: props.eventType,
      eventName: 'login_with_google_button_clicked',
    };
  }

  componentDidMount() {
    const container = document.getElementById('login-with-google');

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;

    // https://developers.google.com/identity/gsi/web/reference/html-reference#data-attributes
    const gIdLoad = document.createElement('div');
    gIdLoad.id = 'g_id_onload';
    gIdLoad.dataset.client_id = window.Livewire.features.googleClientId;
    gIdLoad.dataset.login_uri = window.Livewire.features.googleOauth2Url;
    gIdLoad.dataset.auto_prompt = 'false';

    const gIdSignin = document.createElement('div');
    gIdSignin.classList.add('g_id_signin');
    gIdSignin.dataset.type = 'standard';
    gIdSignin.dataset.size = 'large';
    gIdSignin.dataset.theme = 'outline';
    gIdSignin.dataset.text = 'sign_in_to_LiveWire_with';
    gIdSignin.dataset.shape = 'rectangular';
    gIdSignin.dataset.logo_alignment = 'left';
    gIdSignin.dataset.click_listener = 'onGoogleButtonClick';

    container.appendChild(script);
    container.appendChild(gIdLoad);
    container.appendChild(gIdSignin);

    document.addEventListener('onGoogleButtonClick', () => {
      recordEvent({
        event: this.state.eventName,
        id: 0,
        statisticable: 'navigation',
        page: window.location.pathname,
        custom_data: { page: `/${this.state.eventType}` },
      });
    });
  }

  render() {
    return (
      <div id="login-with-google" />
    );
  }
}

GoogleButton.propTypes = {
  eventType: PropTypes.string.isRequired,
};
